import copy from '../../../copy/en/common.json' with { type: 'json' };
import type { ReactNode } from "react";
import { Link } from "react-router";

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  if (!items.length) return null;
  return (
    <nav className="breadcrumbs" aria-label={copy.PageHeader.breadcrumb}>
      {items.map((c, i) => (
        <span key={`${c.label}-${i}`} className="row" style={{ gap: "var(--space-2)" }}>
          {i > 0 ? (
            <span className="breadcrumbs__sep" aria-hidden>
              /
            </span>
          ) : null}
          {c.to ? (
            <Link to={c.to}>{c.label}</Link>
          ) : (
            <span className="breadcrumbs__current" aria-current="page">
              {c.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}

export interface PageHeaderProps {
  title: ReactNode;
  /** Use a nested heading when a route layout already names the page. */
  level?: 1 | 2;
  description?: ReactNode;
  crumbs?: Crumb[];
  /** Contextual actions (buttons, badges) aligned right. */
  actions?: ReactNode;
  /** Small uppercase label above the title. */
  eyebrow?: ReactNode;
}

export function PageHeader({ title, level = 1, description, crumbs, actions, eyebrow }: PageHeaderProps) {
  const Heading = level === 2 ? "h2" : "h1";
  return (
    <header className="page-header">
      <div className="page-header__text">
        {crumbs ? <Breadcrumbs items={crumbs} /> : null}
        {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
        <Heading className="page-header__title">{title}</Heading>
        {description ? <p className="page-header__description">{description}</p> : null}
      </div>
      {actions ? <div className="page-header__actions">{actions}</div> : null}
    </header>
  );
}
